// import React, { useState } from "react";
// import { FaQuoteLeft, FaStar } from "react-icons/fa";

// const testimonials = [
//   {
//     name: "Dhananjay Lenka",
//     role: "Customer",
//     image:
//       "https://media.istockphoto.com/id/1136413215/photo/young-man-at-street-market.jpg?s=612x612&w=0&k=20&c=obnaR5III0jRxHKd4ZPl3LRC2pI792KbHYR2eBzKKe8=",
//     rating: 5,
//     text: "High-quality bricks and fast delivery — couldn’t ask for more. Highly recommend BrickNBar for construction materials.",
//   },
//   {
//     name: "Neha Mohanty",
//     role: "Customer",
//     image:
//       "https://plus.unsplash.com/premium_photo-1723568666044-1b066e26b1fb?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aW5kaWFuJTIwcGVyc29ufGVufDB8fDB8fHww",
//     rating: 4,
//     text: "Ordered electrical switches and fittings — great quality and prompt delivery. BrickNBar is now my go-to site.",
//   },
//   {
//     name: "Rajiv Pradhan",
//     role: "Customer",
//     image:
//       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxDuiTSnPXEDZux5NEHgARnBrCISyawSteAw&s",
//     rating: 5,
//     text: "It’s so convenient to find all construction and interior items in one place. BrickNBar saved me countless trips to stores!",
//   },
//   {
//     name: "Priya Kumari Sahoo",
//     role: "Customer",
//     image:
//       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ72FBQLR2bgffyuceXXqdOtWHIANdQbFt4mA&s",
//     rating: 5,
//     text: "Shopping on BrickNBar was smooth and easy. I could compare products and prices from home.",
//   },
//   {
//     name: "Manish Das",
//     role: "Customer",
//     image:
//       "https://thumbs.dreamstime.com/b/serious-determined-indian-man-shot-outdoors-person-can-also-represent-latin-mexican-male-businessman-executive-46577677.jpg",
//     rating: 4,
//     text: "BrickNBar combines variety, affordability, and quality. It’s my one-stop-shop for all building materials now.",
//   },
// ];

// const Testimonials = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const testimonialsPerPage = 3;

//   const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
//   const startIndex = (currentPage - 1) * testimonialsPerPage;
//   const currentTestimonials = testimonials.slice(
//     startIndex,
//     startIndex + testimonialsPerPage
//   );

//   const handlePrev = () => {
//     setCurrentPage((prev) => Math.max(prev - 1, 1));
//   };

//   const handleNext = () => {
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   };

//   return (
//     <div className="px-4 sm:px-6 lg:px-8 py-8 bg-white">
//       <h2 className="text-3xl font-bold mb-6">Client Testimonials</h2>

//       <div className="grid md:grid-cols-3 gap-6">
//         {currentTestimonials.map((t, index) => (
//           <div
//             key={index}
//             className="border rounded-lg p-6 shadow-sm bg-white hover:shadow-md transition"
//           >
//             <FaQuoteLeft className="text-orange-700 text-3xl mb-4" />
//             <p className="text-gray-600 mb-6 text-sm">{t.text}</p>
//             <div className="flex items-center gap-4">
//               <img
//                 src={t.image}
//                 alt={t.name}
//                 className="w-10 h-10 rounded-full"
//               />
//               <div>
//                 <h4 className="text-sm font-semibold">{t.name}</h4>
//                 <p className="text-xs text-gray-400">{t.role}</p>
//               </div>
//               <div className="ml-auto flex text-orange-400">
//                 {[...Array(t.rating)].map((_, i) => (
//                   <FaStar key={i} />
//                 ))}
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Pagination Controls */}
//       <div className="flex justify-center items-center mt-8 gap-4">
//         <button
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//           className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
//         >
//           Previous
//         </button>
//         <span className="text-sm font-medium">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//           className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Testimonials;

import React, { useState, useEffect } from "react";
import { FaQuoteLeft, FaStar, FaPlus, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import AddTestimonialModal from "../Testimonials/AddTestimonialModal";

const Swal = {
  fire: (options) => {
    if (options.icon === "success") {
      toast.success(`Success: ${options.title}`);
    } else if (options.icon === "error") {
      toast.error(`Error: ${options.title}`);
    }
  },
};

const TestimonialSkeleton = () => (
  <div className="border rounded-lg p-4 sm:p-6 shadow-sm bg-white animate-pulse">
    <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gray-200 rounded mb-3 sm:mb-4"></div>
    <div className="space-y-2 mb-4 sm:mb-6">
      <div className="h-3 sm:h-4 bg-gray-200 rounded w-full"></div>
      <div className="h-3 sm:h-4 bg-gray-200 rounded w-3/4"></div>
      <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/2"></div>
    </div>
    <div className="flex items-center gap-2 sm:gap-4">
      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-200 rounded-full flex-shrink-0"></div>
      <div className="flex-1 min-w-0">
        <div className="h-3 sm:h-4 bg-gray-200 rounded w-20 sm:w-24 mb-1"></div>
        <div className="h-2 sm:h-3 bg-gray-200 rounded w-12 sm:w-16"></div>
      </div>
      <div className="flex gap-1 flex-shrink-0">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="w-3 h-3 sm:w-4 sm:h-4 bg-gray-200 rounded"
          ></div>
        ))}
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const testimonialsPerPage = 3;

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      // Optional: Add a small delay to make skeletons visible
      await new Promise((resolve) => setTimeout(resolve, 500));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/testinomial/get-all-testinomial`
      );
      const result = await response.json();

      if (result.success) {
        setTestimonials(result.data);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to fetch testimonials",
        });
      }
    } catch (error) {
      console.error("Error fetching testimonials:", error);
      Swal.fire({
        icon: "error",
        title: "Error fetching testimonials",
      });
    } finally {
      setLoading(false);
    }
  };

  // Create new testimonial
  const createTestimonial = async (testimonialData) => {
    try {
      setLoading(true); // Set loading to true before creating
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/testinomial/create-testinomial`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(testimonialData),
        }
      );

      const result = await response.json();

      if (response.ok && result.success) {
        Swal.fire({
          icon: "success",
          title: "Testimonial added successfully!",
        });
        await fetchTestimonials(); // Wait for the fetch to complete
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to add testimonial",
        });
      }
    } catch (error) {
      console.error("Error creating testimonial:", error);
      Swal.fire({
        icon: "error",
        title: "Error creating testimonial",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const startIndex = (currentPage - 1) * testimonialsPerPage;
  const currentTestimonials = testimonials.slice(
    startIndex,
    startIndex + testimonialsPerPage
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const renderStars = (rating = 5) => {
    return [...Array(rating)].map((_, i) => (
      <FaStar key={i} className="text-orange-400" />
    ));
  };

  return (
    <div className="px-3 sm:px-4 md:px-6 lg:px-8 py-6 sm:py-8 bg-white">
      {/* Header Section - Responsive */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4 sm:gap-0">
        <h2 className="text-2xl sm:text-3xl font-bold">Client Testimonials</h2>
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition text-sm sm:text-base w-full sm:w-auto justify-center sm:justify-start"
        >
          <FaPlus className="text-sm" /> Add Testimonial
        </button>
      </div>

      {/* Testimonials Grid - Responsive */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {loading ? (
          // Show skeleton loaders while loading (initial load or after adding)
          [...Array(3)].map((_, index) => <TestimonialSkeleton key={index} />)
        ) : currentTestimonials.length > 0 ? (
          currentTestimonials.map((testimonial, index) => (
            <div
              key={testimonial._id || index}
              className="border rounded-lg p-4 sm:p-6 shadow-sm bg-white hover:shadow-md transition"
            >
              <FaQuoteLeft className="text-orange-700 text-2xl sm:text-3xl mb-3 sm:mb-4" />
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm leading-relaxed line-clamp-4">
                {testimonial.message}
              </p>
              <div className="flex items-center gap-2 sm:gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover flex-shrink-0"
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/40x40?text=User";
                  }}
                />
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold truncate">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-gray-400 capitalize truncate">
                    {testimonial.personType || "Customer"}
                  </p>
                </div>
                <div className="ml-auto flex gap-0.5 sm:gap-1 flex-shrink-0">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className="text-orange-400 text-xs sm:text-sm"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-1 sm:col-span-2 lg:col-span-3 text-center py-8 sm:py-12">
            <p className="text-gray-500 text-sm sm:text-base">
              No testimonials found.
            </p>
          </div>
        )}
      </div>

      {/* Pagination Controls - Responsive */}
      {!loading && testimonials.length > testimonialsPerPage && (
        <div className="flex flex-col sm:flex-row justify-center items-center mt-6 sm:mt-8 gap-3 sm:gap-4">
          <button
            onClick={handlePrev}
            disabled={currentPage === 1}
            className="w-full sm:w-auto px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Previous
          </button>
          <span className="text-xs sm:text-sm font-medium order-first sm:order-none">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="w-full sm:w-auto px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed transition text-sm sm:text-base"
          >
            Next
          </button>
        </div>
      )}

      <AddTestimonialModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={createTestimonial}
      />
    </div>
  );
};

export default Testimonials;
